/**
 * Created by vtbelo on 17/03/21
 */

const PixelsSwarm = function (pixelsPlanner, options) {
    this.pixelsPlanner = pixelsPlanner;
    this.amountPixels = options.amount;
    this.type = options.type;
    this.leftPixels = 0;

    this.createPixels();
};

PixelsSwarm.prototype.onDiePixel = function () {
    this.leftPixels--;
    if (!this.leftPixels) {
        this.pixelsPlanner.startCurrentLevel();
    }
};

PixelsSwarm.prototype.createPixels = function () {
    let pixels = [];

    const types = this.type ? [this.type] : Object.keys(PixelsSwarmConfig);

    types.forEach(function (type) {
        const config = PixelsSwarmConfig[type];

        if (config.pages && config.pages.indexOf(cleverapps.meta.selectedLocationId()) === -1) {
            return;
        }

        if (config.mission) {
            const mission = cleverapps.missionManager.findByType(config.mission);
            if (!mission || !mission.isRunning()) {
                return;
            }
        }

        if (config.filter && !config.filter()) {
            return;
        }

        if (config.limit) {
            if (cleverapps.adsLimits.state(AdsLimits.TYPES.PIXEL_CREATE) !== AdsLimits.STATE_READY) {
                return;
            }
            cleverapps.adsLimits.watch(AdsLimits.TYPES.PIXEL_CREATE);
        }

        if (type === PixelsSwarm.FRIEND) {
            return;
        }

        const amount = Math.ceil(config.amount || this.amountPixels * (config.amountCoef || 1));

        for (let j = 0; j < amount; j++) {
            pixels.push(new Pixel({
                type,
                order: j,
                amountPixels: this.amountPixels,
                onDiePixel: this.onDiePixel.bind(this),
                collectPrize: this.pixelCollectPrize.bind(this)
            }));
        }
    }, this);

    const offer = cleverapps.offerManager.findOffer({ type: Offers.TYPES.PIXEL_OFFER });
    if (offer) {
        this.pixelsPlanner.onCreatePixelOffer(new PixelOffer(offer));
    }

    pixels = PseudoRandom.GET().shuffle(pixels);
    pixels.forEach(function (pixel) {
        this.pixelsPlanner.onCreatePixel(pixel);
    }, this);

    this.leftPixels = pixels.length;
};

PixelsSwarm.prototype.pixelCollectPrize = function () {
    if (!this.pixelCollected) {
        this.pixelCollected = true;
        this.pixelsPlanner.nextLevel();
    }

    cleverapps.eventBus.trigger("taskEvent", "COLLECT_PIXEL");
};

PixelsSwarm.FRUIT = "fruit";
PixelsSwarm.ENERGY = "energy";
PixelsSwarm.COINS = "coins";
PixelsSwarm.ADS = "ads";
PixelsSwarm.FRIEND = "friend";

const PixelsSwarmConfig = {};

PixelsSwarmConfig[PixelsSwarm.FRUIT] = {
    pages: ["main"],
    reward: [{
        units: [{ type: "fruit", stage: 0 }]
    }]
};

PixelsSwarmConfig[PixelsSwarm.ENERGY] = {
    amountCoef: 0.5,
    mission: Mission.TYPE_LIVESFEAST,
    pages: ["main"],
    reward: {
        resource: "energy",
        amount: [2, 8]
    }
};

PixelsSwarmConfig[PixelsSwarm.ADS] = {
    amount: 1,
    limit: AdsLimits.TYPES.PIXEL,
    pages: ["main"],
    reward: [{
        units: [{ code: "telly", stage: 0 }]
    }]
};

PixelsSwarmConfig[PixelsSwarm.FRIEND] = {
    pages: ["main"],
    reward: [{
        units: [
            { code: "energycup", stage: 0 }
        ]
    }],
    maxAmount: 5
};
